<template>
  <main class="collections-page bottom-bg">
    <h1>
      KOLEKCJE: <span class="acier">{{ this.$parent.total_results }}</span>
    </h1>
    <div class="col-filters">
      <div class="col-filter col-filter-showall">
        <a title="Pokaż wszystko">Pokaż wszystkie kolekcje</a
        >
      </div>
      <div class="col-filter col-filter-az" ref="col-filter-az">
        <a @click="sortAZ()" title="Pokaż w kolejności alfabetycznej">A-Z</a
        ><span class="up not-visible" ref="az-up">&#8593;</span>
        <span class="down not-visible" ref="az-down">&#8595;</span>
      </div>
      <div class="col-filter col-filter-byid">
        <a @click="sortById()" title="Pokaż według daty dodania">Data dodania</a
        ><span class="up not-visible" ref="byid-up">&#8593;</span> <span class="down" ref="byid-down">&#8595;</span>
      </div>
    </div>
    <a
      href="javascript:void(0)"
      class="collections-control arrow-link go-left"
      v-show="this.$parent.collections.length > 1"
    >
      <div class="arrow-wrapper">
        <svg viewBox="0 0 113.7 90">
          <path
            class="arrow"
            d="M113.7,45 98.7,29.9 68.8,0 58.2,10.7 77.4,29.9 77.4,29.9 0,29.9 0,45 Z"
          />
          <path
            class="arrow arrow2"
            d="M0,45 0,60.1 77.4,60.1 77.4,60.1 58.2,79.3 68.8,90 98.7,60.1 113.7,45 Z"
          />
        </svg>
      </div>
    </a>
    <div class="swiper-container" ref="swcl">
      <div class="swiper-wrapper" :style="this.$parent.swiper_style">
        <div
          class="swiper-slide"
          v-for="(collection,index) in this.$parent.collections"
          v-bind:key="collection.id"
          :style="'padding-left:' + doMath(index) + 'rem'"
        >
          <!-- data-index - required to show correct image on mouseover -->
          <router-link
            :to="{ name: 'Collection', params: { id: collection.id } }"
            :data-index="collection.index"
            :title="collection.title"
            ><h2>
              <span class="acier" v-if="!null">{{ collection.count }}</span>
              {{ collection.title }}
            </h2></router-link
          >
        </div>
      </div>
    </div>
    <div class="featured-images" v-if="null">
      <img
        :src="collection.image"
        :alt="collection.id"
        :class="{ shown: collection.index == 0 }"
        v-for="collection in this.$parent.collections"
        v-bind:key="collection.id"
      />
    </div>
    <a
      href="javascript:void(0)"
      class="collections-control arrow-link go-right"
      v-show="this.$parent.collections.length > 1"
    >
      <div class="arrow-wrapper">
        <svg viewBox="0 0 113.7 90">
          <path
            class="arrow"
            d="M113.7,45 98.7,29.9 68.8,0 58.2,10.7 77.4,29.9 77.4,29.9 0,29.9 0,45 Z"
          />
          <path
            class="arrow arrow2"
            d="M0,45 0,60.1 77.4,60.1 77.4,60.1 58.2,79.3 68.8,90 98.7,60.1 113.7,45 Z"
          />
        </svg>
      </div>
    </a>
  </main>
</template>

<script>
import { eventBus } from "@/main.js";

export default {
  name: "CollectionsContent",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      hide_arrow: "hide_arrow",
      sort_az: "d",
      sort_id: "d"
    };
  },
  methods: {
    doMath(i){
      return 6
    },
    showAll: function() {
      //eventBus.$emit("showAll");
    },
    sortAZ: function () {
      this.$refs['az-up'].classList.add('not-visible')
      this.$refs['az-down'].classList.add('not-visible')
      if (this.sort_az == "d") {
        this.sort_az = "a";
        this.$refs['az-up'].classList.remove('not-visible')
      } else {
        this.sort_az = "d";
        this.$refs['az-down'].classList.remove('not-visible')
      }
      // hide sth
      this.$refs['byid-up'].classList.add('not-visible')
      this.$refs['byid-down'].classList.add('not-visible')
      eventBus.$emit("sort", ['az',this.sort_az]);
    },
    sortById: function () {
      this.$refs['byid-up'].classList.add('not-visible')
      this.$refs['byid-down'].classList.add('not-visible')

      if (this.sort_id == "d") {
        this.sort_id = "a";
        this.$refs['byid-up'].classList.remove('not-visible')
      } else {
        this.sort_id = "d";
        this.$refs['byid-down'].classList.remove('not-visible')
      }
      // hide sth
      this.$refs['az-up'].classList.add('not-visible')
      this.$refs['az-down'].classList.add('not-visible')
      eventBus.$emit("sort", ['id',this.sort_id]);
    },
  },
  destroyed() {},
  mounted: function () {
  },
};
</script>

<style scoped>
main { 
  min-height: 80vh;
}

.hide_arrow {
  visibility: hidden !important;
}
.featured-images img {
  height: 300px;
  width: auto;
}

.col-filters {
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
  text-transform: uppercase;
}

.col-filters div {
  padding-left: 0px;
}

.col-filter span {
  font-size: 2em;
}

.col-filters a {
  cursor: pointer;
}

.not-visible {
  display: none;
}

.swiper-slide {
}

.collections-page .swiper-container {
}

.collections-page .swiper-container {
  height: 80vh;
  max-height: unset;
  /* height: 80vh !important;
  max-height: none !important; */
}

.swiper-wrapper {
}

.swiper-wrapper div {
height: 10%;
}


@media (max-width: 768px) and (orientation: landscape) {
    .collections-page .swiper-container {
        padding: 0 0.9375rem 0 0.9375rem;
    }
    
    .swiper-wrapper div {
      min-height: 20vh;
    }
}

@media (max-width: 768px) {
  .swiper-wrapper div {
      min-height: 2vh;
    }
}

@media (max-width: 1400px) {
  .swiper-wrapper div {
    min-height: unset;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/Collections/CollectionsContent.vue